/**
 * Debounces a function call.
 *
 * @param {Function} callback Function to debounce.
 * @param {number}   delay    Delay in milliseconds.
 * @return {Function} Debounced function.
 */
export const debounce = ( callback, delay ) => {

	let timer;

	return ( ...args ) => {

		clearTimeout( timer );

		timer = setTimeout( () => {

			callback( ...args );

		}, delay );

	};

};

/**
 * Parses an integer and returns a fallback value when parsing fails.
 *
 * @param {string|number|undefined|null} value    Value to parse.
 * @param {number}                       fallback Fallback value.
 * @return {number} Parsed integer.
 */
export const parseInteger = ( value, fallback = 0 ) => {

	const parsedValue = Number.parseInt( value, 10 );

	return Number.isNaN( parsedValue ) ? fallback : parsedValue;

};

/**
 * Clamps a number to the provided range.
 *
 * @param {number} value Value to clamp.
 * @param {number} min   Minimum allowed value.
 * @param {number} max   Maximum allowed value.
 * @return {number} Clamped value.
 */
export const clamp = ( value, min, max ) => Math.min( Math.max( value, min ), max );
